import React, { useState } from "react";
import "./MWebLeaserboard.css";
import PageChanger from "./PageChanger";
import "./PageChanger.css";
import { motion, AnimatePresence } from "motion/react";

const MWebLeaderboard = ({ data = [], isAttempted, eventMode }) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(data.length / itemsPerPage);

  if (data.length === 0) return null;

  const paginatedData = data.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className="MWebLeaserboard_cont">
      <AnimatePresence mode="wait">
        <motion.div
          key={`${isAttempted}-${page}`}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {paginatedData.map((student, index) => (
            <div key={index} className="MWebLeaserboard_detailbox">
              <div className="MWebLeaserboard_titlebox">
                <h3>{student.student_name || "N/A"}</h3>
                {isAttempted ? (
                  <p className="MWebLeaserboard_titlebox_rank">
                    #{student.rank}
                  </p>
                ) : (
                  <p className="MWebLeaserboard_titlebox_notattempted">
                    Unattempted
                  </p>
                )}
              </div>

              {isAttempted ? (
                <>
                  <p className="MWebMarks_cont">
                    {student.marks_obtained || 0}/{student.total_marks || 0}{" "}
                    Marks
                  </p>
                  <div className="MWebAcc_cont">
                    <p>Accuracy: {student.accuracy || "--"}%</p>
                    {eventMode?.toLowerCase() === "online" && (
                      <p>Time: {student.total_time || "--"}</p>
                    )}
                  </div>
                </>
              ) : (
                <p className="MWeb_notattempted_text">
                  This student did not attempt the test
                </p>
              )}
            </div>
          ))}
        </motion.div>
      </AnimatePresence>
      {totalPages > 1 && (
        <PageChanger
          page={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default MWebLeaderboard;
